import Layout from "components/Layout/Layout";
import LoginRoutes from "components/Layout/Routes/LoginRoutes";
import Home from "pages/Home/Home";
import Login from "pages/Login/Login";
import Ripeness from "pages/Ripeness/Ripeness";
import { createBrowserRouter } from "react-router-dom";
import { RoutePath } from "./paths";
import Dashboard from "pages/DashBoard/Dashboard";

export const router = createBrowserRouter([
  {
    element: <LoginRoutes />,
    children: [
      { path: RoutePath.login, element: <Login /> },
      { path: RoutePath.home, element: <Home /> },
    ],
  },
  {
    element: <Layout />,
    children: [
      // { path: RoutePath.confirm, element: <Confirm /> },
      // { path: RoutePath.reconfirm, element: <Reconfirm /> },
      { path: RoutePath.ripeness, element: <Ripeness /> },
      { path: RoutePath.dashborad, element: <Dashboard /> },
    ],
  },
]);
